import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { PautaService } from "../services/pauta.service";

@Injectable({
  providedIn: 'root'
})
export class PautaResolver implements Resolve<boolean> {

  constructor(private service: PautaService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class PautaCombosResolver{

  constructor(private service: PautaService) { }

  resolve(id:number = null): Observable<any> {
    return this.service.getListCombos(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class PautaCombosResolverAgency{

  constructor(private service: PautaService) { }

  resolve(id:number = null): Observable<any> {
    return this.service.getListCombosAgency(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class PautaResolverId {

  constructor(private service: PautaService) { }

  getById(id:number): Observable<any> {
    return this.service.getById(id);
  }
}